import React from 'react';
import './SiteRefreshPreview.css';
import PreviewHeader from '../../components/SiteRefreshPreview/PreviewHeader';
import PreviewHero from '../../components/SiteRefreshPreview/PreviewHero';
import PreviewLogoStrip from '../../components/SiteRefreshPreview/PreviewLogoStrip';
import PreviewCaseStudies from '../../components/SiteRefreshPreview/PreviewCaseStudies';
import PreviewServices from '../../components/SiteRefreshPreview/PreviewServices';
import PreviewAbout from '../../components/SiteRefreshPreview/PreviewAbout';
import PreviewCta from '../../components/SiteRefreshPreview/PreviewCta';
import PreviewFooter from '../../components/SiteRefreshPreview/PreviewFooter';
import { SiteRefreshThemeProvider, useSiteRefreshTheme } from './SiteRefreshThemeContext';
import {
  navLinks,
  previewCases,
  previewLogos,
  previewServices,
  previewStats,
  socialLinks,
} from './siteRefreshContent';

const SiteRefreshPreviewContent = () => {
  const { theme } = useSiteRefreshTheme();

  return (
    <div className="site-refresh" id="top" data-theme={theme}>
      <PreviewHeader links={navLinks} />
      <PreviewHero />
      <PreviewLogoStrip logos={previewLogos} />
      <PreviewCaseStudies items={previewCases} />
      <PreviewServices items={previewServices} />
      <PreviewAbout stats={previewStats} />
      <PreviewCta />
      <PreviewFooter socialLinks={socialLinks} />
    </div>
  );
};

const SiteRefreshPreview = () => (
  <SiteRefreshThemeProvider>
    <SiteRefreshPreviewContent />
  </SiteRefreshThemeProvider>
);

export default SiteRefreshPreview;
